import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ClassifierValueCard, UpdateClassifierValueRequest } from 'types/classifier.interface';
import { AbstractControl, FormBuilder, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { SpinnerComponent } from 'components/spinner/spinner.component';
import { BaseFormModalComponent } from '../base-form-modal.component';
import { ToastService } from 'services/toast.service';
import { getControlsWithErrors, MAX_LENGTH_NAME } from 'util/form.utility';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-edit-classifier-value',
  standalone: true,
  imports: [TranslateModule, FormsModule, SpinnerComponent, ReactiveFormsModule, NgClass],
  templateUrl: './edit-classifier-value.component.html',
  styleUrl: './edit-classifier-value.component.scss'
})
export class EditClassifierValueComponent extends BaseFormModalComponent implements OnInit {
  @Input() value!: ClassifierValueCard;
  @Input() siblingValues: ClassifierValueCard[] = [];
  @Output() save: EventEmitter<UpdateClassifierValueRequest> = new EventEmitter<UpdateClassifierValueRequest>();
  isUniqueValue: boolean = true;
  updatedName: string = '';

  get name(): AbstractControl<any, any> | null {
    return this.form.get('name');
  }

  constructor(
    formBuilder: FormBuilder,
    config: NgbModalConfig,
    modalService: NgbModal,
    toastService: ToastService,
    translateService: TranslateService
  ) {
    super(formBuilder, config, modalService, toastService, translateService);
  }

  ngOnInit() {
    this.fillForm();
  }

  fillForm(): void {
    this.form = this.formBuilder.group({
      name: [this.value.name, [Validators.required, Validators.maxLength(MAX_LENGTH_NAME)]]
    });
  }

  handleSave() {
    if (this.form.valid && this.validateUniqueValue()) {
      this.submitAttempted = false;
      this.save.emit({
        ...this.value,
        name: this.name?.value
      });
    } else {
      this.submitAttempted = true;
      this.toastService.showFormValidationError(getControlsWithErrors(this.form), 'components.editClassifierGroup');
    }
  }

  resetForm(): void {
    this.name?.setValue(this.value.name);
  }

  protected override close(): void {
    this.resetForm();
    super.close();
  }

  validateUniqueValue(): boolean {
    this.isUniqueValue = !this.siblingValues.some(
      (value) => value.id !== this.value.id && !value.isDeleted && value.name!.toLowerCase() === this.name?.value.toLowerCase()
    );

    return this.isUniqueValue;
  }
}
